module.exports = __webpack_public_path__ + "img/cyndi.fb5ac17b.jpg";